import 'numeral/locales/en-gb';
import FundingDonationsList from '~/javascripts/components/Project/FundingDonationsList';
import Modal from '~/javascripts/behaviors/Modal';
import ReactPaginate from 'react-paginate';
import VirginiaClayCampaignPanel from '~/javascripts/components/Project/VirginiaClayCampaignPanel';
import cx from 'classnames';
import numeral from 'numeral';
import pluralize from 'pluralize';
import queryString from 'query-string';
import { Component } from 'react';
import { isEmpty } from 'lodash';

class FundingCampaignsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      campaignCount: 0,
      campaignCountry: '',
      campaigns: [],
      currentPage: 0,
      displayDonationsForCampaigns: [],
      totalPages: 0,
      loading: true,
    };
  }

  initData = () => {
    let requestData = {};
    requestData = queryString.parse(window.location.search);

    if (isEmpty(requestData)) {
      requestData['page'] = 1;
    }

    this.getCampaigns(requestData);
  };

  getCampaigns = (requestData) => {
    $.ajax({
      url: `/projects/${this.props.grantNumber}-${this.props.projectNumber}/funding_campaigns`,
      data: requestData,
      dataType: 'json',
      type: 'GET',

      success: (data) => {
        this.setState(data);
        this.setState({ loading: false });
      },
    });
  };

  handlePageClick = (data) => {
    this.setState(
      { currentPage: data.selected },
      this.getCampaigns({ page: data.selected + 1 })
    );
  };

  toggleDonationList = (element, campaignId) => {
    if (!element.target.classList.contains('campaign-name')) {
      this.setState({
        displayDonationsForCampaigns:
          this.state.displayDonationsForCampaigns.includes(campaignId)
            ? this.state.displayDonationsForCampaigns.filter(
                (x) => x !== campaignId
              )
            : this.state.displayDonationsForCampaigns.concat([campaignId]),
      });
    }
  };

  shouldShowDonationList = (campaignId, visible) =>
    visible &&
    (this.state.campaignCount === 1 ||
      this.state.displayDonationsForCampaigns.includes(campaignId));

  shouldShowVirginiaClaySpecifics = () => this.props.grantNumber == '123';

  setLocaleForCampaignCountry = () =>
    this.state.campaignCountry === 'uk'
      ? numeral.locale('en-GB')
      : numeral.locale('en');

  componentDidMount() {
    this.highlightedCampaignId = parseInt(
      queryString.parse(window.location.search).campaign_id
    );

    this.initData();
    if (this.sponsor) Modal($(this.sponsor));
  }

  render() {
    this.setLocaleForCampaignCountry();

    return (
      <div
        className={cx('campaign-info', {
          'single-funding-campaign':
            this.state.campaignCount == 1 && !this.props.otherDonations,
          paginated: this.state.totalPages > 1,
          loading: this.state.loading,
        })}
      >
        <div className='row'>
          <div
            className={cx(
              'panel campaign-funding-count bg-cw-brand-yellow-300',
              {
                hidden: this.state.loading,
              }
            )}
          >
            <h5 className='heading-small text-cw-black campaign-count-header text-left'>
              Funded by{' '}
              {this.shouldShowVirginiaClaySpecifics() && 'Virginia Clay, '}
              donors from {this.state.campaignCount} campaigns
              {this.props.otherDonations && ' and other donations'}
            </h5>
          </div>
          {this.shouldShowVirginiaClaySpecifics() && (
            <VirginiaClayCampaignPanel name='virginia_clay' />
          )}
          {this.state.campaigns.map((campaign) => (
            <div key={campaign.numericalCampaignId}>
              <div
                className={cx(
                  'campaign',
                  'panel',
                  this.shouldShowDonationList(
                    campaign.numericalCampaignId,
                    campaign.visible
                  )
                    ? 'open'
                    : 'closed',
                  {
                    invis: !campaign.visible,
                    last:
                      campaign == this.state.campaigns.slice(-1)[0] &&
                      !this.shouldShowVirginiaClaySpecifics(),
                  }
                )}
                onClick={(e) =>
                  this.toggleDonationList(e, campaign.numericalCampaignId)
                }
              >
                <div
                  className={cx('row', {
                    highlight:
                      campaign.numericalCampaignId ==
                      this.highlightedCampaignId,
                  })}
                >
                  <div className='large-8 medium-8 small-11 columns'>
                    <h5 className='heading-small text-grey-50 funded-by-label'>
                      Funded By
                    </h5>
                    <h5 className='heading-small text-cw-black pb-1'>
                      {campaign.visible ? (
                        <a
                          className='campaign-name no-underline text-cw-black'
                          href={campaign.path}
                          rel='noopener noreferrer'
                        >
                          {campaign.name}
                        </a>
                      ) : (
                        campaign.name
                      )}
                      {campaign.recognized && (
                        <a
                          className='no-underline text-cw-black'
                          href='#sponsor'
                          ref={(el) => (this.sponsor = el)}
                        >
                          <span className='icon cw-icon-star' />
                        </a>
                      )}
                    </h5>
                    <p className='body-s em campaigner-info'>
                      {campaign.userName} -{' '}
                      {campaign.amountContributed == campaign.amountRaised
                        ? numeral(campaign.amountRaised).format('$0,0[.]00')
                        : `${numeral(campaign.amountContributed).format(
                            '$0,0[.]00'
                          )} of ${numeral(campaign.amountRaised).format(
                            '$0,0[.]00'
                          )}`}
                    </p>
                  </div>
                  <div className='large-4 medium-4 small-1 columns'>
                    <div className='float-right'>
                      <span
                        className={cx(
                          'label-xs donation-count text-cw-brand-grey-800 pr-0',
                          {
                            'pr-2':
                              this.state.campaignCount > 1 && campaign.visible,
                          }
                        )}
                      >
                        {`${campaign.contributionCount} ${pluralize(
                          'donation',
                          campaign.contributionCount
                        )}`}
                      </span>
                      {this.state.campaignCount > 1 && campaign.visible && (
                        <span className='donations-caret'>
                          <span className='cw-icon-caret-down text-cw-brand-grey-800' />
                          <span className='cw-icon-caret-up text-cw-brand-grey-800' />
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={cx(
                  'donations-container',
                  this.shouldShowDonationList(
                    campaign.numericalCampaignId,
                    campaign.visible
                  )
                    ? 'open'
                    : 'closed'
                )}
              >
                {this.shouldShowDonationList(
                  campaign.numericalCampaignId,
                  campaign.visible
                ) && (
                  <FundingDonationsList
                    campaignCount={this.state.campaignCount}
                    grantNumber={this.props.grantNumber}
                    numericalCampaignId={campaign.numericalCampaignId}
                    otherDonations={this.props.otherDonations}
                    projectNumber={this.props.projectNumber}
                  />
                )}
              </div>
            </div>
          ))}
          {this.shouldShowVirginiaClaySpecifics() && (
            <VirginiaClayCampaignPanel name='wallstrom' />
          )}
        </div>
        {this.state.totalPages > 1 && (
          <div
            className={cx('row panel pagination-info paginated-campaigns', {
              rounded: !this.props.otherDonations,
            })}
          >
            <div className='columns large-12'>
              <div className='pagination small float-right'>
                <ReactPaginate
                  breakLabel={null}
                  forcePage={this.state.currentPage - 1}
                  marginPagesDisplayed={0}
                  nextLabel={[
                    <span className='cw-icon-angle-right' key='next' />,
                  ]}
                  onPageChange={this.handlePageClick}
                  pageCount={this.state.totalPages}
                  pageRangeDisplayed={4}
                  previousLabel={[
                    <span className='cw-icon-angle-left' key='prev' />,
                  ]}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FundingCampaignsList;
